import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import Swal from "sweetalert2";
import { PedidoService } from "src/app/core/services/pedido-service";
import { Order } from "src/app/core/entities/order";
import { ToastrService } from "ngx-toastr";
import { ConfiguracoesSite } from "src/app/core/entities/configuracoesSite";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { ProductService } from "src/app/core/services/product-service";
import { CurrencyPipe } from "@angular/common";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Observable } from "rxjs";
import { UsuarioService } from "src/app/core/services/usuario-service";
import { TypeaheadMatch } from "ngx-bootstrap/typeahead";
import { formatDate } from "@angular/common";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { SecurityService } from "src/app/core/services/security-service";
import { DownloadImagesService } from "src/app/core/services/download-images.service";
import { InitProvider } from "src/app/core/services/init-provider";
import { RelatorioService } from "src/app/core/services/relatorios.service";
import {
  gerarPDFComProdutos,
  gerarPDFPedidos,
} from "src/app/core/services/pdf-generator.service";
import { DateRangeOption } from "src/app/core/interfaces/date-range";
import { DateRangeFactoryService } from "src/app/core/services/date-range-factory.service";

declare var $: any;
import "@angular/localize/init";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-page-pedidos",
  templateUrl: "./page-pedidos.component.html",
  styleUrls: ["./page-pedidos.component.css"],
})

export class PagePedidosComponent implements OnInit {
  SITE: ConfiguracoesSite;
  public layout: number;
  public page: String = "ABERTO";
  public pedidoDelete: Order;
  public excel: any[] = ["DETALHADO"];
  qrCode: any = {};
  public pedidoCopy: Order;
  public pedidos: Order[] = [];
  public pedido: any;
  public pedidoItens = [];
  public pedidoClienteSelected = { todos: true };
  public empty: boolean = false;
  public subTotal: number = 0;
  public valorTotal: number = 0;
  public acrescimoTotal: number = 0;
  public descontoTotal: number = 0;
  public impostosTotal: number = 0;
  public quantidadeTotal: number = 0;
  public formSearch: FormGroup;
  public loadPdf: boolean = false;
  public orderItens: any[] = [];
  public loadImgs: boolean = false;
  usuarios: Observable<any[]>;
  clientes: Observable<any[]>;
  typingUsuario: string;
  typingCliente: string;
  public ranges: DateRangeOption[] = [];
  public loadNota: boolean = false
  public pageable;
  public pageNumber = 1;
  public mapItens;
  public mapProdutos;
  public tablePedidoView;
  public tablePedidoAberto;
  private currencyPipe: CurrencyPipe = new CurrencyPipe("pt-BR");
  statusERPs = [];
  public isGestor = false;

  constructor(
    private router: Router,
    private rangeFactory: DateRangeFactoryService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    public pedidoService: PedidoService,
    public productService: ProductService,
    private usuarioService: UsuarioService,
    private relatorioService: RelatorioService,
    private formBuilder: FormBuilder,
    private localeService: BsLocaleService,
    private toastService: ToastrService,
    private downloadService: DownloadImagesService,
    public initProvider: InitProvider,
    public securityService: SecurityService
  ) {
    this.layout = Configuracoes.layout;
    this.SITE = Configuracoes.SITE;
    this.excel = Configuracoes.layoutExcelPedido
      ? Configuracoes.layoutExcelPedido
      : this.excel;
    this.loadPdf = false;
    this.isGestor = this.securityService.isType("GESTOR");
    this.localeService.use("pt-custom");
    this.formSearch = this.formBuilder.group({
      usuario: [""],
      cliente: [""],
      data: [[]],
      statusERP: [""],
      pedido: [""],
    });
    this.route.queryParams.subscribe((params) => {
      if (params["page"]) this.page = params["page"];
      else this.page = "ABERTO";

      /*$('#usuario').val('');
      $('#usuario').removeClass('is-valid is-invalid');
      $('#cliente').val('');
      $('#cliente').removeClass('is-valid is-invalid');
      this.formSearch.reset();*/
      this.formSearch.controls.statusERP.setValue("");
      this.statusERPs = [];
      this.pedidos = [];
      if (this.pageNumber == 1) {
        this.init();
      } else {
        this.pageNumber = 1;
      }
    });
    this.usuarios = Observable.create((observer: any) => {
      if (!this.usuarioService.loading) {
        this.usuarioService.getUsuarios(
          this.typingUsuario,
          function (resp) {
            observer.next(resp);
          }.bind(this)
        );
      }
    });
    this.clientes = Observable.create((observer: any) => {
      if (!this.usuarioService.loading) {
        this.usuarioService.getClientes(
          {
            busca: this.typingCliente,
            id_usuario: this.initProvider.usuario.id,
          },
          function (resp) {
            observer.next(resp);
          }.bind(this)
        );
      }
    });
  }

  ngOnInit() {
    this.ranges = this.rangeFactory.getDefaultRanges();
  }
  async gerar(dados) {
    await gerarPDFComProdutos(dados);
  }

  async download(p: Order) {
    this.loadImgs = true;
    // this.downloadService.append(images);
    this.downloadService.getFotosPedido(p.id, (resp) => {
      this.downloadService.append(resp);
      this.downloadService.download(`fotos_pedido ${p.id}`);
      this.loadImgs = false;
    });

    // for (let index = 0; index < p.itens.length; index++) {
    //   const i = p.itens[index];
    //   const resp = await this.productService.getPhotosPromesse(i.produto);
    //   let images = resp.map((r) => Configuracoes.API_IMAGENS_PRODUTOS + r.nome);
    //   this.downloadService.append(images);
    // }
    // this.downloadService.download(`fotos_pedido ${p.id}`);
  }

  init() {
    let form = { page: this.pageNumber - 1 };
    if (this.formSearch.value.cliente) {
      form["cliente"] = this.formSearch.value.cliente;
    }
    if (this.formSearch.value.usuario) {
      form["usuario"] = this.formSearch.value.usuario;
    }
    if (
      this.formSearch.value.data &&
      this.formSearch.value.data[0] &&
      this.formSearch.value.data[1]
    ) {
      form["dataInicial"] = formatDate(
        this.formSearch.value.data[0],
        "dd/MM/yyyy",
        "en"
      );
      form["dataFinal"] = formatDate(
        this.formSearch.value.data[1],
        "dd/MM/yyyy",
        "en"
      );
    }
    if (this.formSearch.value.statusERP) {
      form["statusERP"] = this.formSearch.value.statusERP;
    }
    if (this.formSearch.value.pedido) {
      form["pedido"] = this.formSearch.value.pedido;
    }
    if (this.page == "SALVO") {
      this.pedidoService.listaPedidoOrcamento(form, this.callback.bind(this));
    }
    if (this.page == "TODOS") {
      form["tipo"] = this.page;
      this.pedidoService.listaPedidoCliente(
        form,
        this.callback.bind(this),
        function (error) {
          this.empty = true;
        }.bind(this)
      );
    }

    if (this.page == "ABERTO") {
      if (this.SITE.salvaCheckout) {
        this.pedidoService.listaPedido(
          form,
          this.callback.bind(this),
          "ABERTO"
        );
      } else {
        this.pedidoService.listaPedido(form, this.callback.bind(this), false);
        // this.pedidoService.listaPedido(form, this.callback.bind(this), 'ABERTO');
      }
    } else if (this.page == "EM_ANDAMENTO" || this.page == "CONCLUIDO") {
      form["tipo"] = this.page;
      this.pedidoService.getStatusERP(
        form,
        function (resp) {
          this.statusERPs = resp;
        }.bind(this)
      );
      this.pedidoService.listaPedidoCliente(
        form,
        this.callback.bind(this),
        function (error) {
          this.empty = true;
        }.bind(this)
      );
    }
  }

  // Função para converter URL de imagem em Base64
  getBase64ImageFromURL(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        if (ctx) {
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL("image/png");
          resolve(dataURL);
        } else {
          reject("Erro ao obter contexto do canvas");
        }
      };
      img.onerror = (error) => reject(error);
      img.src = url;
    });
  }

  pageChanged(e: any): void {
    this.pageNumber = e.page;
    this.init();
  }

  callback(p) {
    this.pageable = p;
    this.pedidos = p.content;
    if (this.pedidos.length > 0) this.empty = false;
    else this.empty = true;
  }

  onSubmitSearch() {
    if (this.pageNumber == 1) {
      this.init();
    } else {
      this.pageNumber = 1;
    }
  }

  onSelectUsuario(event: TypeaheadMatch): void {
    this.formSearch.controls.usuario.setValue(event.item.id);
    $("#usuario").blur();
    $("#usuario").removeClass("is-valid is-invalid");
    $("#usuario").addClass("is-valid");
    $("#btnFormSearch").focus();
  }

  typeaheadNoResultsUsuario(event: boolean): void {
    this.formSearch.controls.usuario.setValue("");
    $("#usuario").removeClass("is-valid is-invalid");
    $("#usuario").addClass("is-invalid");
  }

  copyLink(link) {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        this.toastService.success(
          $localize`Link copiado com sucesso para a área de transferência$localize`,
          $localize`Produto$localize`,
          {
            positionClass: "toast-bottom-left",
          }
        );
      })
      .catch((err) => {
        this.toastService.warning(
          $localize`Erro ao copiar link para a área de transferência`,
          $localize`Produto`,
          {
            positionClass: "toast-bottom-left",
          }
        );
      });
  }

  onSelectCliente(event: TypeaheadMatch): void {
    this.formSearch.controls.cliente.setValue(event.item.id);
    $("#cliente").blur();
    $("#cliente").removeClass("is-valid is-invalid");
    $("#cliente").addClass("is-valid");
    $("#btnFormSearch").focus();
  }

  typeaheadNoResults(event: boolean): void {
    //if(event){
    this.formSearch.controls.cliente.setValue("");
    $("#cliente").removeClass("is-valid is-invalid");
    $("#cliente").addClass("is-invalid");
    //}
  }

  copiaErrorMsg(text) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.toastService.success(
          $localize`Mensagem copiada com sucesso para a área de transferência`,
          $localize`Pedido`,
          {
            positionClass: "toast-bottom-left",
          }
        );
      })
      .catch((err) => {
        this.toastService.warning(
          $localize`Erro ao copiar link para a área de transferência`,
          $localize`Produto`,
          {
            positionClass: "toast-bottom-left",
          }
        );
      });
  }

  showPedido(p: Order) {
    let selectedP: any = {};
    let pedido;
    if (this.page === "TODOS" || this.page === "EM_ANDAMENTO" || this.page === "CONCLUIDO") {
      pedido = p.numero_pedido;
      this.pedidoService.pedidoCliente(pedido, (e) => {
        selectedP = { ...e, infos: p.infos };
        this.subTotal = 0;
        this.valorTotal = 0;
        this.acrescimoTotal = 0;
        this.descontoTotal = 0;
        this.impostosTotal = 0;
        this.quantidadeTotal = 0;
        this.pedidoClienteSelected = { todos: true };
        this.pedido = selectedP;
        this.orderItens = selectedP.itens;
        this.pedido.clientes.forEach(
          (pc) => (this.pedidoClienteSelected[pc.cliente["id"]] = true)
        );
        this.agruparPorProdutoReferencia(this.orderItens);
        this.atualizaPedidoItens();
      });
    } else {
      pedido = p.id;
      this.pedidoService.getPedidoId(pedido, (e) => {
        selectedP = { ...e, infos: p.infos };
        this.subTotal = 0;
        this.valorTotal = 0;
        this.acrescimoTotal = 0;
        this.descontoTotal = 0;
        this.impostosTotal = 0;
        this.quantidadeTotal = 0;
        this.pedidoClienteSelected = { todos: true };
        this.pedido = selectedP;
        this.orderItens = selectedP.itens;
        this.pedido.clientes.forEach(
          (pc) => (this.pedidoClienteSelected[pc.cliente["id"]] = true)
        );
        this.agruparPorProdutoReferencia(this.orderItens);
        this.atualizaPedidoItens();
      });
    }
  }

  showPedidoFinalizado(p: any) {
    this.pedido = p;
    this.orderItens = p.itens;
    this.mapaItensEProdutos();
    this.tablePedidoView = "";
    this.agruparPorProdutoReferencia(this.orderItens)
    // this.productService.findByMap(
    //   this.mapProdutos,
    //   function (resp) {
    //     if (resp) {
    //       let refs = [];
    //       this.mapProdutos = resp;
    //       for (let key of Object.keys(this.mapProdutos)) {
    //         refs.push({
    //           id: this.mapProdutos[key].id,
    //           ref: this.mapProdutos[key].referencia,
    //         });
    //       }
    //       refs.sort(this.sort1);
    //       refs.forEach((r) => {
    //         this.tablePedidoView += this.table1(
    //           this.mapProdutos[r.id],
    //           this.mapItens[r.id]
    //         );
    //       });
    //     }
    //   }.bind(this)
    // );
  }


  atualizaPedidoItens() {
    this.tablePedidoAberto = "";
    this.subTotal = 0;
    this.valorTotal = 0;
    this.acrescimoTotal = 0;
    this.descontoTotal = 0;
    this.impostosTotal = 0;
    this.quantidadeTotal = 0;
    let mapClientes = {};
    for (let key of Object.keys(this.pedidoClienteSelected)) {
      if (key != "todos") {
        if (this.pedidoClienteSelected[key]) mapClientes[key] = 1;
      }
    }

    let itens = [];
    this.pedido.itens.forEach((i) => {
      if (mapClientes[i.cliente]) {
        this.quantidadeTotal += i.quantidade;
        let naoExiste = true;
        itens.forEach((x) => {
          if (
            x.produto == i.produto &&
            x.cor == i.cor &&
            x.estampa == i.estampa &&
            x.tamanho == i.tamanho
          ) {
            naoExiste = false;
            x.quantidade += i.quantidade;
            x.total += i.total;
          }
        });
        if (naoExiste) itens.push(Object.assign({}, i));
      }
    });
    this.mapaItensEProdutosPedidoAberto(itens);
    // this.productService.findByMap(
    //   this.mapProdutos,
    //   function (resp) {
    //     if (resp) {
    //       let refs = [];
    //       this.mapProdutos = resp;
    //       for (let key of Object.keys(this.mapProdutos)) {
    //         refs.push({
    //           id: this.mapProdutos[key].id,
    //           ref: this.mapProdutos[key].referencia,
    //         });
    //       }
    //       refs.sort(this.sort1);
    //       refs.forEach((r) => {
    //         this.tablePedidoAberto += this.table1(
    //           this.mapProdutos[r.id],
    //           this.mapItens[r.id]
    //         );
    //       });
    //     }
    //   }.bind(this)
    // );

    if (this.pedido.clientes) {
      this.pedido.clientes.forEach((c) => {
        if (this.pedidoClienteSelected[c.cliente.id]) {
          this.subTotal += c.subtotal;
          this.acrescimoTotal += c.acrescimo;
          this.descontoTotal += c.desconto;
          this.impostosTotal += c.impostos;
          this.valorTotal += c.total;
        }
      });
    }
  }

  getLinkAprovaCliente(p, idPedidoCliente) {
    if (
      this.SITE.precoDivergenteTabelaMin != null &&
      this.SITE.precoDivergenteTabelaIdeal != null &&
      p.precoDivergenteStatus == 2
    ) {
      this.toastService.error(
        $localize`Preço divergente pendente`,
        $localize`Aprovação Cliente`
      );
      return;
    }

    if (!p.quantidade) {
      this.toastService.error(
        $localize`Pedido vazio`,
        $localize`Aprovação Cliente`
      );
      return;
    }

    this.pedidoService.getAprovaPedidoLink(
      idPedidoCliente,
      function (resp) {
        $("#inputLinkAprovaCliente").val(resp.link);
        let el = document.getElementById("inputLinkAprovaCliente") as any;
        el.select();
        el.setSelectionRange(0, 99999);
        document.execCommand("copy");
        this.toastService.success(
          $localize`Copiado para área de transferência`,
          $localize`Aprovação Cliente`
        );
      }.bind(this)
    );
  }

  confirmCopy(p: Order) {
    this.pedidoCopy = p;
  }

  confirmDel(event: Event, p: Order) {
    if (this.page === 'ABERTO' && !this.pedidoService.allowDelete) {
      event.preventDefault();
      event.stopPropagation();

      this.toastService.warning(
        "Você não tem permissão para apagar esse pedido",
        "Pedido"
      );
      return;
    }

    this.pedidoDelete = p;
  }


  selectPedido(p: Order) {
    this.pedidoService.getPedidoId(p.id, (e) => {
      if (!this.pedidoService.confirmaTrocaPedido(p)) {
        return;
      }
      if (p.salvoCheckout) {
        Swal.fire({
          title: $localize`Confirma edição?`,
          icon: "warning",
          html: $localize`Pedido salvo anteriormente, será necessário reconfirmar o checkout`,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: true,
          confirmButtonText: $localize`Editar`,
          cancelButtonText: $localize`Cancelar`,
        }).then((result) => {
          if (result.value) {
            this.pedidoService.editSalvaCheckout(
              p.id,
              function (resp) {
                this.pedidoService.select(resp);
                this.toastService.info(
                  $localize`Pedido #` + p.id + $localize` selecionado!`
                );
                if (
                  !window.localStorage.getItem("visualizacaoModo") &&
                  Configuracoes.modoVisualizacaoCatalogo
                )
                  window.localStorage.setItem(
                    "visualizacaoModo",
                    Configuracoes.modoVisualizacaoCatalogo
                  );
                this.router.navigate(["/catalogo"]);
              }.bind(this)
            );
          }
        });
      } else {
        this.pedidoService.select(e);
        // this.pedidoService.select(p);
        this.toastService.info(
          $localize`Pedido #` + e.id + $localize` selecionado!`
        );

        if (
          !window.localStorage.getItem("visualizacaoModo") &&
          Configuracoes.modoVisualizacaoCatalogo
        )
          window.localStorage.setItem(
            "visualizacaoModo",
            Configuracoes.modoVisualizacaoCatalogo
          );

        this.router.navigate(["/catalogo"]);
      }
    });
  }
  copyOrder(p: Order, i: number) {
    this.pedidoService.getPedidoId(p.id, (e) => {
      this.pedidoService.selectCopy(e, i);
      this.router.navigate(["/copia-pedido"]);
    });
  }

  copyOrderFinalizada(p: Order, i: number) {
    this.pedidoService.pedidoCliente(p.pedido, (e) => {
      this.pedidoService.selectCopy(e, i);
      this.router.navigate(["/copia-pedido"]);
    });
  }
  selectPedidoOrcamento(p: Order) {
    this.pedidoService.getPedidoId(p.id, (e) => {
      if (!this.pedidoService.confirmaTrocaPedido(p)) {
        return;
      }
      if (p.salvoCheckout) {
        Swal.fire({
          title: $localize`Confirma edição?`,
          icon: "warning",
          html: $localize`Pedido salvo anteriormente, será necessário reconfirmar o checkout`,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: true,
          confirmButtonText: $localize`Editar`,
          cancelButtonText: $localize`Cancelar`,
        }).then((result) => {
          if (result.value) {
            this.pedidoService.editSalvaCheckout(
              p.id,
              function (resp) {
                this.pedidoService.select(resp);
                this.toastService.info(
                  $localize`Pedido #` + p.id + $localize` selecionado!`
                );
                if (
                  !window.localStorage.getItem("visualizacaoModo") &&
                  Configuracoes.modoVisualizacaoCatalogo
                )
                  window.localStorage.setItem(
                    "visualizacaoModo",
                    Configuracoes.modoVisualizacaoCatalogo
                  );
                this.router.navigate(["/catalogo"]);
              }.bind(this)
            );
          }
        });
      } else {
        this.pedidoService.select(e);
        // this.pedidoService.select(p);
        this.toastService.info(
          $localize`Pedido #` + e.id + $localize` selecionado!`
        );

        if (
          !window.localStorage.getItem("visualizacaoModo") &&
          Configuracoes.modoVisualizacaoCatalogo
        )
          window.localStorage.setItem(
            "visualizacaoModo",
            Configuracoes.modoVisualizacaoCatalogo
          );

        this.router.navigate(["/orcamento"]);
      }
    });
  }

  toHome() {
    this.router.navigate(["/"]);
  }
  duplicaPedido(pedido) {
    let pedidoIdCliente =
      pedido.id_pedido_cliente ? pedido.id_pedido_cliente : pedido.pedido;

    let pedidoId = pedido.id_pedido ? pedido.id_pedido : pedido.id;
    this.pedidoService.duplicaPedido(
      pedidoId,
      pedidoIdCliente,
      function (res) {
        this.init();
        Swal.fire($localize`Pedido`, $localize`Copiado com sucesso`, "success");
        $("#pedidoModal").modal("hide");
        $("#pedidoModalFinalizado").modal("hide");
      }.bind(this),
      (res) => this.callBackDuplicarErro(res)
    );
  }

  gerarLinkPagamento(p) {
    this.usuarioService.consultaPix(
      {
        pedido_cliente: p.pedido,
      },
      function (resp) {
        this.qrCode = resp;
        $("#pixModal").modal("show");
      }.bind(this),
      function (resp) {
        let res = resp._body;
        this.toastService.info(JSON.parse(res).detail, "Pix", {
          timeOut: 4000,
        });
      }.bind(this)
    );
  }

  duplicaPedidoDig(pedido) {
    for (let j = 0; j < pedido.clientes.length; j++) {
      this.pedidoService.duplicaPedido(
        pedido.id,
        pedido.clientes[j].id,
        function (res) {
          this.init();
          Swal.fire(
            $localize`Pedido`,
            $localize`Copiado com sucesso`,
            "success"
          );
          $("#pedidoModal").modal("hide");
          $("#pedidoModalFinalizado").modal("hide");
        }.bind(this),
        (res) => this.callBackDuplicarErro(res)
      );
    }
  }

  callBackDuplicarErro(res) {
    if (res && res._body) {
      this.toastService.error(
        JSON.parse(res._body).detail,
        "Erro ao Duplicar pedido"
      );
    } else {
      this.toastService.error("Algo deu errado", "Erro ao Duplicar pedido");
    }
  }
  selectPedidoCheckout(p: Order) {
    if (!this.pedidoService.confirmaTrocaPedido(p)) return;
    this.pedidoService.getPedidoId(p.id, (e) => {
      this.pedidoService.select(e);
      this.toastService.info(
        $localize`Pedido #` + p.id + $localize` selecionado!`
      );
      this.router.navigate(["/checkout"]);
    });
  }

  copyPedido() {
    this.pedidoService.copy(
      this.pedidoCopy,
      function () {
        this.init();
        Swal.fire($localize`Pedido`, $localize`Copiado com sucesso`, "success");
      }.bind(this)
    );
  }

  redirectCopyPedido(p: Order) {
    this.router.navigate(["/novo-pedido"], { state: p });
  }

  printPedidoById(pcId) {
    this.pedidoService.getPedidoCliente(
      pcId,
      function (resp) {
        this.printPedido(resp);
      }.bind(this)
    );
  }

  downloadFile(url, fileName) {
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Erro ao baixar o arquivo");
        }
        return response.blob();
      })
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Remove o link após o clique
      })
      .catch((error) => {
        console.error("Erro:", error);
      });
  }

  printNota(nota) {

    // se existir link, apenas abre em outra aba
    if (nota.link) {
      window.open(Configuracoes.API_DOCS+"/"+nota.link, "_blank");
      return;
    }

    const headers = new Headers({
      Branch: Configuracoes.API_BRANCH,
      Authorization: "Bearer " + window.localStorage.getItem("token"),
    });

    if (nota.tipo.toLoweCase() === "danfe") {
      this.loadNota = true;

      fetch(`${Configuracoes.API}impressoes/documento?id_documento=${nota.id}`, {
        method: "GET",
        headers,
      })
        .then(response => response.text())
        .then((jsonResposta) => {
          this.relatorioService.getDanfePdf(
            jsonResposta,
            (pdf) => {
              window.open(pdf.arquivo);
              this.loadNota = false;
            },
            (erro) => {
              console.error("Erro ao gerar PDF", erro);
              this.loadNota = false;
            }
          );
        })
        .catch(err => {
          console.error("Erro ao buscar XML", err);
          this.toastService.error(err, "Erro ao buscar XML");
          this.loadNota = false;
        });

      return;
    }

    this.loadNota = true;

    fetch(`${Configuracoes.API}impressoes/documento?id_documento=${nota.id}`, {
      method: "GET",
      headers,
    })
      .then(response => response.text())
      .then((xml) => {
        const blob = new Blob([xml], { type: "application/xml" });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `${nota.numero_nota}.xml`;

        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        this.loadNota = false;
      })
      .catch(err => {
        console.error("Erro ao buscar XML", err);
        this.loadNota = false;
      });
  }
  agruparPorProduto(itens: any[]): Map<string, any[]> {
    const map = new Map<string, any[]>();
    for (const item of itens) {
      if (!map.has(item.descricao)) {
        map.set(item.descricao, []);
      }
      map.get(item.descricao)!.push(item);
    }
    return map;
  }
  async mapPedidoToLayout(pedido: any): Promise<any> {
    try {
      const clienteData = this.page !== "ABERTO" && this.page !== "SALVO" ? pedido.cliente : pedido.clientes ? pedido.clientes?.[0]?.cliente : pedido.cliente;
      // const clienteData = pedido.pedido
      
      let enderecoSelecionado =
        clienteData?.enderecos?.find((e: any) => e.selecionado)
        ?? clienteData?.endereco;
      if ((enderecoSelecionado && enderecoSelecionado.length === 0) || enderecoSelecionado === undefined) {
        enderecoSelecionado = clienteData.enderecos.filter(e => e.selecionado)
      }

      // 🔹 Aguarda o retorno do serviço
      const source = await new Promise<any>((resolve, reject) => {
        // if (this.page !== "ABERTO") {
        this.pedidoService.pedidoCliente(pedido.pedido ? pedido.pedido : pedido.id, (response: any, error?: any) => {
          if (error) {
            reject(error);
          } else {
            resolve(response);
          }
        });
        // } else {
        // this.pedidoService.getPedidoId(pedido.id, (response: any, error?: any) => {
        //   if (error) {
        //     reject(error);
        //   } else {
        //     resolve(response);
        //   }
        // });
        // }
      });

      // console.log(source)
      // console.log(clienteData)
      // console.log(pedido)

      // 🔹 Retorno OK
      let endereco = source.clientes?.[0]?.cliente.enderecos[0]
      if (this.layout === 4) {
        return {
          layout: "pedido",
          dados: {
            url_imagens: Configuracoes.API_IMAGENS,
            url_imagens_produtos: Configuracoes.API_IMAGENS + "produtos/",
            logo: Configuracoes.API_IMAGENS + "logo.png",

            pedido: {
              numero: String(
                source.pedido ??
                source.numero_pedido ??
                source.id_pedido_cliente ??
                source.id_pedido_ ??
                source.id
              ),
              data: source.data,
              status: source.status,
              forma_pagamento: source.formaPagamento?.descricao ?? "",
              tipo_pedido: source.tipo?.descricao ?? "",
              transportadora: source.freteNome ?? "",
              obs: source.observacao ?? ""
            },

            cliente: {
              nome: source.clientes[0].cliente?.nome ?? "",
              cnpj: source.clientes[0].cliente?.documento ?? source.clientes[0].cliente?.cnpj ?? "",
              email: source.clientes[0].cliente?.email ?? "",
              fone: `(${source.clientes[0].cliente?.ddd ?? ""}) ${source.clientes[0].cliente?.telefone ?? source.clientes[0].cliente?.fone ?? ""}`,
              endereco: endereco
                ? `${endereco.endereco}, ${endereco.numero} - ${endereco.bairro}, ${endereco.nomecidade} - ${endereco.uf}, ${endereco.cep}`
                : ""
            },

            produtos: (source.itens ?? []).map((item: any) => ({
              // imagem vem como "nome" no JSON novo
              imagem: item.imagem ?? item.nome ?? "",

              // código pode vir de várias formas
              codigo:
                item.codigo ??
                item.produtoReferencia ??
                String(item.produto ?? ""),

              descricao: item.descricao + " - " + item.tamanho + " - " + item.descricao_cor,
              ncm: item.ncm ?? "",
              barra: item.codigobarra ?? item.codigobarras ?? "",

              quantidade: item.quantidade ?? 0,
              preco_unitario: item.preco_tabela ?? 0,

              // impostos no JSON novo
              ipi: item.ipi ?? item.imp_valoripi ?? 0,
              st: item.st ?? item.imp_valorsubst ?? 0
            })),

            resumo: {
              desconto:
                source.desconto ??
                source.clientes?.[0]?.desconto ??
                0,

              frete: source.freteValor ?? 0
            }
          }
        }
      } else if (this.layout === 3) {
        const produtos: any = this.agruparPorProduto(source.itens)
        const produtosArr = Array.from(produtos.values()).map((items: any[]) => {
          const primeiro = items[0]

          const variacoesMap: any = {}

          items.forEach((item) => {
            const cor = item.descricao_cor ?? ""
            const tamanho = item.tamanho ?? ""
            const quantidade = item.quantidade ?? 0

            if (!variacoesMap[cor]) {
              variacoesMap[cor] = {
                cor,
                tamanhos: {}
              }
            }

            variacoesMap[cor].tamanhos[tamanho] =
              (variacoesMap[cor].tamanhos[tamanho] ?? 0) + quantidade
          })

          return {
            imagem: primeiro.imagem ?? primeiro.nome ?? "",

            codigo:
              primeiro.codigo ??
              primeiro.produtoReferencia ??
              String(primeiro.produto ?? ""),

            descricao: primeiro.descricao ?? "",

            ncm: primeiro.ncm ?? "",

            preco_unitario: primeiro.preco_tabela ?? 0,

            variacoes: Object.values(variacoesMap)
          }
        })
        return {
          layout: "pedido_grade",
          dados: {
            url_imagens: Configuracoes.API_IMAGENS,
            url_imagens_produtos: Configuracoes.API_IMAGENS + "produtos/",
            logo: Configuracoes.API_IMAGENS + "logo.png",

            pedido: {
              numero: String(
                source.pedido ??
                source.numero_pedido ??
                source.id_pedido_cliente ??
                source.id_pedido_ ??
                source.id
              ),
              data: source.data,
              status: source.status,
              forma_pagamento: source.formaPagamento?.descricao ?? "",
              tipo_pedido: source.tipo?.descricao ?? "",
              transportadora: source.freteNome ?? "",
              obs: source.observacao ?? ""
            },

            cliente: {
              nome: clienteData?.nome ?? "",
              cnpj: clienteData?.documento ?? clienteData?.cnpj ?? "",
              email: clienteData?.email ?? "",
              fone: `(${clienteData?.ddd ?? ""}) ${clienteData?.telefone ?? ""}`,
              endereco: endereco
                ? `${endereco.endereco}, ${endereco.numero} - ${endereco.bairro}, ${endereco.nomecidade} - ${endereco.uf}, ${endereco.cep}`
                : ""
            },

            produtos: produtosArr,

            resumo: {
              desconto:
                source.desconto ??
                source.clientes?.[0]?.desconto ??
                0,

              frete: source.freteValor ?? 0
            }
          }
        }
      }


    } catch (error) {
      console.error("Erro ao buscar pedido:", error);

      // 🔴 Retorno de erro padronizado
      return {
        layout: "pedido",
        erro: true,
        mensagem: "Erro ao carregar dados do pedido",
        detalhes: error
      };
    }
  }

  async printPedidoPdf(p) {
    const pedidoData = await this.mapPedidoToLayout(p);
    this.loadPdf = true;
    try {
      const pedido: any = await new Promise((resolve, reject) => {
        this.pedidoService.getPedidoIdPdf(
          // p.pedido ? p.pedido : p.numero_pedido,
          pedidoData,
          (res) => {
            if (res) {
              resolve(res);
            } else {
              console.error("Erro ao carregar pedido");
              reject("Erro ao carregar pedido");
            }
          },
          (res) => {
            this.toastService.warning($localize`Erro desconhecido`);
            this.loadPdf = false;
          }
        );
      });

      // await gerarPDFPedidos(pedido, this.layout);
      if (pedido.arquivo) {
        window.open(pedido.arquivo, '_blank');
      }
      this.loadPdf = false;

    } catch (erro) {
      console.error("Erro geral no processo:", erro);
    } finally {
      this.loadPdf = false;
    }
  }

  printPedidoPdfServer(pcId) {
    this.loadPdf = true;
    const headers = new Headers({
      Branch: Configuracoes.API_BRANCH,
      Authorization: "Bearer " + window.localStorage.getItem("token"),
    });
    fetch(
      `${Configuracoes.PDF}impressoes/pedido?pedido=${pcId}&layout=${Configuracoes.layout}`,
      {
        method: "GET",
        headers,
      }
    )
      .then((response) => {
        this.loadPdf = false;
        return response.blob();
      })
      .then((blob) => {
        this.loadPdf = false;
        let url = window.URL.createObjectURL(blob);
        window.open(url);
      })
      .catch((e) => {
        this.toastService.warning($localize`Erro desconhecido`);
        this.loadPdf = false;
      });
  }

  debugBase64(base64URL) {
    var win = window.open();
    win.document.write(
      '<iframe src="' +
      base64URL +
      '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
    );
  }
  callbackExcel(res, pedido) {
    const url = window.URL.createObjectURL(new Blob([res]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `planilha_pedido_${pedido.id}.xlsx`); // Nome do arquivo para download
    document.body.appendChild(link);
    link.click();
    link.remove(); // Remove o link após o clique

    this.toastService.success($localize`Planilha exportada!`);
  }
  printPedidoExcel(p, e) {
    this.pedidoService.exportPlanilha(
      p,
      e,
      function (res) {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `planilha_pedido_${p.id}.xlsx`); // Nome do arquivo para download
        document.body.appendChild(link);
        link.click();
        link.remove(); // Remove o link após o clique

        this.toastService.success($localize`Planilha exportada!`);
      }.bind(this)
    );
  }

  printPedido(p) {
    this.pedido = p;
    this.mapaItensEProdutos();
    //https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
    //http://detectmobilebrowsers.com/
    const isMobile =
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        navigator.userAgent || navigator.vendor
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        (navigator.userAgent || navigator.vendor).substr(0, 4)
      );
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(
      window.navigator.userAgent
    );
    const isChrome =
      /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

    this.productService.findByMap(
      this.mapProdutos,
      function (resp) {
        if (resp) {
          this.mapProdutos = resp;
          if (isMobile || isIEOrEdge) {
            this.pedidoService.pedidoPDF(
              this.pedido,
              this.mapProdutos,
              this.mapItens,
              "download"
            );
          } else {
            $("#printPedidoModal").modal("show");
            $("#printPedidoModal .modal-body").empty();
            if (isChrome) {
              $("#printPedidoModal .modal-body").append(
                '<embed src="' +
                this.pedidoService.pedidoPDF(
                  this.pedido,
                  this.mapProdutos,
                  this.mapItens,
                  "bloburi"
                ) +
                '" style="width:100%;height:842pt;"></embed>'
              );
            } else {
              let obj = document.createElement("object");
              obj.style.width = "100%";
              obj.style.height = "842pt";
              obj.type = "application/pdf";
              obj.data = this.pedidoService.pedidoPDF(
                this.pedido,
                this.mapProdutos,
                this.mapItens,
                "data"
              );
              $("#printPedidoModal .modal-body").append(obj);
            }
          }
        }
      }.bind(this)
    );
  }

  mapaItensEProdutos() {
    this.mapItens = {};
    this.pedido.itens.forEach((i) => {
      if (this.mapItens[i.produto]) {
        this.mapItens[i.produto].push(i);
      } else {
        this.mapItens[i.produto] = [i];
      }
    });
    this.mapProdutos = {};
    this.pedido.itens.forEach((i) => {
      this.mapProdutos[i["produto"] as any] = null;
    });
  }

  mapaItensEProdutosPedidoAberto(itens) {
    this.mapItens = {};
    itens.forEach((i) => {
      if (this.mapItens[i.produto]) {
        this.mapItens[i.produto].push(i);
      } else {
        this.mapItens[i.produto] = [i];
      }
    });
    this.mapProdutos = {};
    itens.forEach((i) => {
      this.mapProdutos[i["produto"] as any] = null;
    });
  }

  changePedidoClienteSelectedTodos() {
    if (this.pedidoClienteSelected.todos) {
      for (var i = 0; i < this.pedido.clientes.length; i++) {
        this.pedidoClienteSelected[this.pedido.clientes[i]["cliente"]["id"]] =
          true;
      }
    } else {
      for (var i = 0; i < this.pedido.clientes.length; i++) {
        this.pedidoClienteSelected[this.pedido.clientes[i]["cliente"]["id"]] =
          false;
      }
    }
    let pedidoClienteList = this.pedidoClienteSelected;
    delete pedidoClienteList.todos;
    let list = [];

    for (let i in pedidoClienteList) {
      if (pedidoClienteList[i]) {
        list.push(i);
      }
    }
    this.orderItens = this.pedido.itens.filter((i) =>
      list.includes(i.cliente.toString())
    );
    //
    this.pedido.itens = list;
    this.agruparPorProdutoReferencia(this.orderItens);
    this.atualizaPedidoItens();
  }

  changePedidoClienteSelected() {
    this.pedidoClienteSelected.todos = true;
    for (var i = 0; i < this.pedido.clientes.length; i++) {
      if (
        !this.pedidoClienteSelected[this.pedido.clientes[i]["cliente"]["id"]]
      ) {
        this.pedidoClienteSelected.todos = false;
        break;
      }
    }
    let pedidoClienteList = this.pedidoClienteSelected;
    delete pedidoClienteList.todos;
    let list = [];

    for (let i in pedidoClienteList) {
      if (pedidoClienteList[i]) {
        list.push(i);
      }
    }
    this.orderItens = this.pedido.itens.filter((i) =>
      list.includes(i.cliente.toString())
    );
    //
    this.pedido.itens = list;
    this.agruparPorProdutoReferencia(this.orderItens);
    this.atualizaPedidoItens();
  }

  table1(produto, itens) {
    let mapCor = {};
    itens.forEach((i) => {
      if (mapCor[i.cor]) {
        mapCor[i.cor].push(i);
      } else {
        mapCor[i.cor] = [i];
      }
    });
    let head = "<tr><td>COR</td>";
    let rows = [];
    let totalTamanhos = {};
    let totalQtde = 0;
    let totalPreco = 0;
    let totalTotal = 0;
    for (let key of Object.keys(mapCor)) {
      let grade = "<tr><td>" + mapCor[key][0].corDescricao + "</td>";
      let qtde = 0;
      let total = 0;
      produto.tamanhos.forEach((t) => {
        let tamanho = 0;
        mapCor[key].forEach((mC) => {
          if (mC.tamanho == t.tamanho) {
            tamanho = mC.quantidade;
            qtde += mC.quantidade;
            total += mC.total;
            if (totalTamanhos[t.tamanho]) {
              totalTamanhos[t.tamanho] += mC.quantidade;
            } else {
              totalTamanhos[t.tamanho] = mC.quantidade;
            }
          }
        });
        grade += "<td>" + tamanho + "</td>";
      });
      totalQtde += qtde;
      totalPreco += total / qtde;
      totalTotal += total;
      grade += "<td>" + qtde + "</td>";
      grade +=
        "<td>" + this.currencyPipe.transform(total / qtde, "", "") + "</td>";
      grade +=
        "<td>" + this.currencyPipe.transform(total, "", "") + "</td></tr>";
      rows.push(grade);
    }
    let grade = "<tr><td></td>";
    produto.tamanhos.forEach((t) => {
      grade +=
        "<td>" +
        (totalTamanhos[t.tamanho] ? totalTamanhos[t.tamanho] : "") +
        "</td>";
    });
    grade += "<td><b>" + totalQtde + "</b></td>";
    grade +=
      "<td><b>" + this.currencyPipe.transform(totalPreco, "", "") + "</b></td>";
    grade +=
      "<td><b>" +
      this.currencyPipe.transform(totalTotal, "", "") +
      "</b></td></tr>";
    rows.push(grade);
    produto.tamanhos.forEach((t) => {
      head += "<td>" + t.tamanho + "</td>";
    });
    head += "<td>QTDE</td>";
    head += "<td>PREÇO</td>";
    head += "<td>TOTAL</td></tr>";
    return `<div class="table-responsive">
      <table class="table table-hover table-condensed table-striped table-sm table-responsive-xs">
        <thead class="table-head">
            <tr>
                <th colspan="5">${produto.referencia} - ${produto.descricao
      }</th>
            </tr>
        </thead>
        <tbody>
            ${head}
            ${rows.join("")}
        </tbody>
      </table>
    </div>`;
  }

  deletePedido() {
    this.pedidoService.unSelectAndDelete(
      this.pedidoDelete,
      function (resp) {
        this.init();
        Swal.fire(
          $localize`Pedido`,
          $localize`Excluído com sucesso`,
          "success"
        );
      }.bind(this),
      function (error) {
        let obj = error.error
        if (obj && obj.detail) {
          Swal.fire($localize`Pedido`, obj.detail, "warning");
        } else {
          Swal.fire(
            $localize`Pedido`,
            $localize`Sem permissão para excluir pedido`,
            "warning"
          );
        }
      }.bind(this)
    );
  }

  agruparPorProdutoReferencia(data) {
    const agrupado: Record<string, any[]> = {};
    data.forEach((item) => {
      // Usa produtoDescricao, mas se não existir, usa descricao
      const descricao =
        item.produtoDescricao || item.descricao || "Sem descrição";

      if (!agrupado[descricao]) {
        agrupado[descricao] = [];
      }

      agrupado[descricao].push(item);
    });

    this.orderItens = Object.keys(agrupado).map((key) => ({
      produtoReferencia: agrupado[key][0]?.produtoReferencia || "",
      produtoDescricao: key,
      itens: agrupado[key],
    }));
  }
  sumQtd(itens) {
    return itens.reduce(
      (accumulator, object) => accumulator + object.quantidade,
      0
    );
  }
  sumPrc(itens) {
    return itens.reduce((accumulator, object) => accumulator + object.total, 0);
  }
  sort1(a, b) {
    if (a.ref.toLowerCase() > b.ref.toLowerCase()) {
      return 1;
    } else if (a.ref.toLowerCase() < b.ref.toLowerCase()) {
      return -1;
    } else {
      return 0;
    }
  }

  public redirectToRastreio(p: Order) {
    if (p.freteRastreios.length)
      window.open(p.freteRastreios[0].rastreio, "_blank").focus();
    else this.toastService.warning($localize`Sem rastreio associado ao pedido`);
  }

  getSafeImageUrl() {
    // Certifique-se de qrCode.image_qrcode contém a string base64 da imagem
    if (this.qrCode.image_qrcode !== undefined) {
      const imageUrl = "data:image/png;base64," + this.qrCode.image_qrcode;
      return this.sanitizer.bypassSecurityTrustResourceUrl(imageUrl);
    }
  }
}
